export default "__VITE_ASSET__Ba0mlxSR__"